import { useState } from 'react';
import { useInView } from './hooks/useInView';

const FAQS = [
  {
    q: 'What is NOMO?',
    a: 'NOMO is a next-generation Web3 platform combining a non-custodial multi-chain wallet, the Nomo-ID identity protocol, full compatibility with 70+ WebOns (independent decentralized applications), regulated banking access (IBAN, debit card, SEPA), and community governance. It is not another wallet — it is financial infrastructure for the decentralized era.',
  },
  {
    q: 'How do WebOns work?',
    a: 'WebOns are decentralized applications built on an open standard that runs natively inside compatible hosts like the NOMO app. They are independent products — not built or owned by NOMO — but fully integrated into the NOMO experience. There is no browser switching, no wallet extension juggling, and no fragmented UX. Developers build WebOns using the Nomo-WebOn-Kit, and users discover and interact with them directly inside NOMO.',
  },
  {
    q: 'What is Nomo-ID?',
    a: 'Nomo-ID is NOMO\'s open identity protocol — it bridges your verified identity to decentralized ID solutions across the ecosystem. Complete verification once through a compatible provider (such as ZenPass), and your verified identity becomes portable across all connected services. No repeated KYC loops. Your identity remains blockchain-anchored and under your full control.',
  },
  {
    q: 'How do I secure my NOMO wallet?',
    a: 'NOMO provides multiple layers of security: PIN protection, biometric authentication (fingerprint/Face ID), advanced encrypted key management, and secure recovery phrase management. As a non-custodial wallet, your private keys never leave your device. Always store your recovery phrase offline — NOMO never has access to your funds.',
  },
  {
    q: 'Which blockchains does NOMO support?',
    a: 'NOMO currently supports Ethereum, BNB Chain, Polygon, Solana, and additional networks — with cross-chain interaction built into the core. New networks are continuously integrated based on ecosystem demand and community governance decisions.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);
  const [ref, inView] = useInView();

  const toggle = (i) => setOpen(open === i ? null : i);

  return (
    <section className="faq section--dark" id="faq" ref={ref}>
      <div className="section-blobs" aria-hidden="true">
        <div className="blob blob--gold" />
        <div className="blob blob--violet" />
      </div>

      <div className="container" style={{ maxWidth: '860px' }}>
        <div className={`reveal ${inView ? 'in-view' : ''}`}>
          <div className="section-label">FAQ</div>
          <h2 className="section-title section-title--lg" style={{ marginBottom: '3rem' }}>
            Frequently asked{' '}
            <span className="gradient-text">questions.</span>
          </h2>
        </div>

        <div className="glass-wrap">
          <div className={`faq__list stagger ${inView ? 'in-view' : ''}`}>
            {FAQS.map((faq, i) => (
              <div className={`faq-item ${open === i ? 'open' : ''}`} key={faq.q}>
                <div
                  className="faq-item__question"
                  onClick={() => toggle(i)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && toggle(i)}
                  aria-expanded={open === i}
                >
                  <span className="faq-item__q-text">{faq.q}</span>
                  <span className="faq-item__icon" aria-hidden="true">+</span>
                </div>
                <div className="faq-item__answer" aria-hidden={open !== i}>
                  <div className="faq-item__answer-inner">{faq.a}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
